<template>
	<div id="app">
		<router-view v-if="isRouterAlive" />
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		mounted() {
			if (this.isMobile()) {
				// 根据判断结果执行不同的逻辑，例如跳转路由
				let url = '/h5/';
				if(this.$route.query.admin_id){
					url += '?admin_id='+this.$route.query.admin_id;
				}
				window.location.href = url;
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					);
				return !!flag;
			}
		}
	}
</script>
<style>
	body {
		display: block;
		margin: 0px;
	}
</style>
<style lang="scss">
	/*每个页面公共css */
	@import "./common/style_scss.scss";


	@font-face {
		font-family: 'AlimamaFangYuanTiVF-Thin';
		src: url('./assets/fonts/AlimamaFangYuanTiVF-Thin.ttf') format('truetype');
		font-weight: normal;
		font-style: normal;
	}
</style>